/**
 * External dependencies
 */
export default {
	text: {
		type: 'string',
		default: 'Select a pickup point',
	},
    selectButton: {
		type: 'string',
		default: 'Select pickup point',
	},
    changeButton: {
		type: 'string',
		default: 'Modify',
	},
	showIcons: {
		type: 'boolean',
		default: true
	}
};